export enum BannerSize {
  MaxWidth = 3840,
}
